
        var result = require("!!../../../../node_modules/css-loader/index.js!./not-found.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/not-found/not-found.component.css
// module id = 525
// module chunks = 0